import { Alert, Button } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

import { useAuth } from "../auth/AuthProvider";

type Ent = { status?: string; trial_days_left?: number | null; read_only?: boolean; grace_until?: string | null };

/** Trial countdown / past-due / read-only banners driven by `me.entitlements` (CF-0068/69/70). */
export function SubscriptionBanner() {
  const { me, hasPermission } = useAuth();
  const location = useLocation();
  const ent = (me as unknown as { entitlements?: Ent })?.entitlements;
  if (!ent || location.pathname.startsWith("/app/settings/billing")) return null;
  const cta = hasPermission("billing.subscription.change") ? <Button color="inherit" size="small" component={RouterLink} to="/app/settings/billing">Billing</Button> : undefined;
  if (ent.read_only) return <Alert severity="error" sx={{ borderRadius: 0 }} action={cta}>Your subscription is inactive; the workspace is read-only. An owner can fix this under Billing.</Alert>;
  if (ent.status === "past_due") return <Alert severity="warning" sx={{ borderRadius: 0 }} action={cta}>A payment failed. Update the payment method to keep full access.</Alert>;
  if (ent.status === "expired") return <Alert severity="warning" sx={{ borderRadius: 0 }} action={cta}>Your trial has ended. Choose a plan to keep working after the grace period.</Alert>;
  if (ent.status === "trialing" && (ent.trial_days_left ?? 99) <= 7) return <Alert severity="info" sx={{ borderRadius: 0 }} action={cta}>Trial ends in {ent.trial_days_left} day{ent.trial_days_left === 1 ? "" : "s"}.</Alert>;
  return null;
}
